import { Country } from "../types/countryTypes";

/**
 * Persistencia del país seleccionado y de la lista de países del usuario en localStorage.
 * Se centraliza aquí para que tanto el contexto de React como el interceptor de axios
 * lean/escriban de forma consistente.
 */

export const SELECTED_COUNTRY_KEY = "selectedCountry";
export const USER_COUNTRIES_KEY = "userCountries";

/** País actualmente seleccionado (o null). */
export const getSelectedCountry = (): Country | null => {
  try {
    const raw = localStorage.getItem(SELECTED_COUNTRY_KEY);
    return raw ? (JSON.parse(raw) as Country) : null;
  } catch {
    return null;
  }
};

/** Id del país seleccionado (o null). Lo usa el interceptor para la cabecera X-Country-Id. */
export const getSelectedCountryId = (): number | null => {
  const country = getSelectedCountry();
  return country ? country.id : null;
};

export const setSelectedCountry = (country: Country | null): void => {
  if (country) {
    localStorage.setItem(SELECTED_COUNTRY_KEY, JSON.stringify(country));
  } else {
    localStorage.removeItem(SELECTED_COUNTRY_KEY);
  }
};

/** Lista de países a los que el usuario tiene acceso. */
export const getStoredCountries = (): Country[] => {
  try {
    const raw = localStorage.getItem(USER_COUNTRIES_KEY);
    return raw ? (JSON.parse(raw) as Country[]) : [];
  } catch {
    return [];
  }
};

export const setStoredCountries = (countries: Country[]): void => {
  localStorage.setItem(USER_COUNTRIES_KEY, JSON.stringify(countries || []));
};

/** Limpia todo lo relacionado con país (al cerrar sesión o ante un 401). */
export const clearCountryStorage = (): void => {
  localStorage.removeItem(SELECTED_COUNTRY_KEY);
  localStorage.removeItem(USER_COUNTRIES_KEY);
};
